import script from "./adjustment.vue?vue&type=script&setup=true&lang=js"
export * from "./adjustment.vue?vue&type=script&setup=true&lang=js"

import "./adjustment.vue?vue&type=style&index=0&id=222019b8&lang=scss"

const __exports__ = script;

export default __exports__